import { StepProps, Steps, StepsProps } from 'antd';
import React, { useEffect, useMemo } from 'react';

import { useTypedSelector } from '../../hooks/useTypedSelector';
import { SignContract } from '../SignContract';
import { Documents } from './Documents';
import { UserStatus } from './Registration.interfaces';
import styles from './Registration.module.scss';
import { Test } from './Test';
import { UploadSelfie } from './UploadSelfie';
import { Worksheet } from './Worksheet';

export const Registration: React.FC = () => {
  const [current, setCurrent] = React.useState(0);
  const { userInfo } = useTypedSelector((state) => state.registration);

  const disabledPhoto =
    userInfo?.status === UserStatus.CONFIRMATION ||
    userInfo?.status === UserStatus.SIGN_CONTRACT;

  const disabledWorksheet =
    userInfo?.status === UserStatus.IN_SURVEY ||
    userInfo?.status === UserStatus.SIGN_CONTRACT ||
    userInfo?.status === UserStatus.CONFIRMATION;

  const disabledDocs =
    userInfo?.status === UserStatus.IN_SURVEY ||
    userInfo?.status === UserStatus.SIGN_CONTRACT;

  const disabledTest = userInfo?.status !== UserStatus.IN_SURVEY;

  const disabledSignContract = userInfo?.status !== UserStatus.SIGN_CONTRACT;

  const stepsDetail = useMemo(
    (): StepProps[] => [
      {
        title: 'Фото с паспортом',
        disabled: disabledPhoto,
        // TODO: добавить проверку заполнения анкеты, сейчас это работает для селфи, но надо добавить аналогичную
        // TODO: проверку для "Анкета" на то, что обязательные поля заполнены и лучше поля анкеты добавить в массив
        // TODO: это нужно, если человек сразу перейдет в загрузку документов, но забудет заполнить анкету, чтобы не мог отправить на проверку только доки без заполненной анкеты
        // помечаем шаг ошибочным если человек на другом шаге, а в доках нет документа с признаком селфи (не забыть добавить curren в зависимости useMemo)
        // status: (!userInfo?.docs.some((doc) => doc.docTypeIsFoto) && current !== 0) ? 'error' : undefined,
      },
      {
        title: 'Анкета',
        disabled: disabledWorksheet,
      },
      {
        title: 'Документы',
        disabled: disabledDocs,
      },

      {
        title: 'Тестирование',
        description:
          userInfo?.status !== UserStatus.IN_SURVEY
            ? 'Будет доступно после проверки профиля менеджером'
            : undefined,
        disabled: disabledTest,
      },

      {
        title: 'Подписание договора',
        disabled: disabledSignContract,
        description:
          userInfo?.status !== UserStatus.IN_SURVEY
            ? 'Будет доступно после прохождения теста'
            : undefined,
      },
    ],
    [
      userInfo?.status,
      disabledPhoto,
      disabledWorksheet,
      disabledDocs,
      disabledTest,
      disabledSignContract,
    ],
  );

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleChangeStep = (value: number) => {
    setCurrent(value);
  };

  // если анкета  на подтверждении, остальные разделы не доступны
  useEffect(() => {
    if (userInfo?.status === UserStatus.CONFIRMATION) {
      setCurrent(2);
    }

    if (userInfo?.status === UserStatus.IN_SURVEY) {
      setCurrent(3);
    }

    if (userInfo?.status === UserStatus.SIGN_CONTRACT) {
      setCurrent(4);
    }
  }, [userInfo]);

  return (
    <div>
      <h1 className={styles.title}>
        Регистрация клиента ({userInfo?.legalStatus})
      </h1>

      <div className={styles.main}>
        <div className={styles.container}>
          {current === 0 && <UploadSelfie next={next} prev={prev} />}

          {current === 1 && (
            <div>
              <div>
                <Worksheet nextStep={next} prevStep={prev} />
              </div>
            </div>
          )}

          {current === 2 && (
            <div>
              <div>
                <Documents
                  nextStep={next}
                  prevStep={prev}
                  disableEdit={userInfo?.status === UserStatus.CONFIRMATION}
                />
              </div>
            </div>
          )}

          {current === 4 && (
            <div>
              <div>
                <SignContract />
              </div>
            </div>
          )}

          {current === 3 && (
            <div>
              <div>
                <Test />
              </div>
            </div>
          )}
        </div>

        <Steps
          className={styles.steps}
          direction="vertical"
          current={current}
          onChange={handleChangeStep}
          items={stepsDetail}
        />
      </div>
    </div>
  );
};
